import * as React from 'react';
import { ItemForExcel, OrderItemForExcel } from '../../domain/Product';
import ExportDataToExcel, { Column } from '../ExportDataToExcel';
import createExcelFileName from '../createExcelFileName';
import exportIcon from '../img/export.svg';

interface Props {
    onDownloadClicked: (event: React.MouseEvent<HTMLButtonElement>) => void;
    spreadsheetData: ItemForExcel[] | OrderItemForExcel[];
    columns: Column[];
    name: 'Estimations' | 'Order';
}

export default class ExportExcel extends React.PureComponent<Props> {
    public render(): JSX.Element {
        const className = 'estimations-export-button link-button button-' + this.props.name.toString().toLowerCase();
        return (
            <>
                <button className={className} onClick={this.props.onDownloadClicked}>
                    <img src={exportIcon} className="export-button-icon" />
                    <span>(.xls)</span>
                </button>
                <div className="estimations-download-xls">
                    <div className="row text-center">
                        <ExportDataToExcel
                            spreadsheetData={this.props.spreadsheetData}
                            columns={this.props.columns}
                            name={this.props.name}
                            filename={createExcelFileName(this.props.name, new Date())}
                        />
                    </div>
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/common/ExportExcel.tsx